import { render, staticRenderFns } from "./PosicionesAbiertas.vue?vue&type=template&id=4f507fd8&scoped=true&"
import script from "./PosicionesAbiertas.vue?vue&type=script&lang=js&"
export * from "./PosicionesAbiertas.vue?vue&type=script&lang=js&"
import style0 from "./PosicionesAbiertas.vue?vue&type=style&index=0&id=4f507fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f507fd8",
  null
  
)

export default component.exports